import { makeAutoObservable, runInAction } from 'mobx';
import { history } from "../..";
import agent from '../api/agent';

import { SGTComunidad, SGTComunidadFormValues } from '../models/SGTComunidades';

export default class SGTComunidadStore {

    SGTComunidadRegistry = new Map<string, SGTComunidad>();

    selectedSGTComunidad: SGTComunidad | undefined = undefined;
    editMode = false;
    loading = false;
    loadingInitial = false;
    recarga = false
    condicion = false
 

    constructor() {
        makeAutoObservable(this)
    }

    get SGTComunidadByName() {
        return Array.from(this.SGTComunidadRegistry.values());
    }
    
    get groupedSGTComunidades() {
        return this.SGTComunidadRegistry
    }

    loadSGTComunidades = async () => {
        this.loadingInitial = true;
        try {
            const SGTComunidades = await agent.SGTComunidades.list();
            SGTComunidades.forEach(SGTComunidad => {
                this.setSGTComunidad(SGTComunidad);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadSGTComunidad = async (idcomunidad: string) => {
        let SGTComunidad = this.getSGTComunidad(idcomunidad);
        if (SGTComunidad) {
            this.selectedSGTComunidad = SGTComunidad;
            return SGTComunidad;
        } else {
            this.loadingInitial = true;
            try {
                SGTComunidad =  await agent.SGTComunidades.details(idcomunidad);
                this.setSGTComunidad(SGTComunidad);
                runInAction(() => {
                    this.selectedSGTComunidad = SGTComunidad;
                })
                this.setLoadingInitial(false);
                return SGTComunidad;
       
            } catch (error) {
                this.setLoadingInitial(false);
                return SGTComunidad;
            }
        }
    }
  
    private setSGTComunidad = (SGTComunidad: SGTComunidad) => {
        
        this.SGTComunidadRegistry.set(SGTComunidad.idComunidad, SGTComunidad);
    }

    private getSGTComunidad = (iddeparta: string) => {
        return this.SGTComunidadRegistry.get(iddeparta);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }


}